import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/Footer';
import Form from '../../components/form/Form';
import Navigation from '../../components/navigation/Navigation';
import './thankyouMessage.css'

const renderSubscribeForm = (item, index) => (
    <React.Fragment key={index}>
        <div className='input-black'>
            <input
                required
                type={item.type}
                placeholder={item.placeholder}
                value={item.value}
                onChange={item.onChange}
            />
        </div>
    </React.Fragment>
)

const renderLoading = () => (
    <Spinner animation="border" variant="light"/>
)

function ThankyouMessage() {
    const [loading, setLoading] = useState();
    const [email, setEmail] = useState();

    const subscribeInputData = [
        {
            type: 'text',
            placeholder: 'Email Address',
            value: email,
            onChange: (e) => setEmail(e.target.value)
        }
    ]

    const handleSubscribeForm = e => {
        e.preventDefault();
        setLoading(true);
    }

    return (
        <div className='thankyou_message'>
            <Navigation background="theme-color" logo="https://res.cloudinary.com/emacon-production/image/upload/v1638427484/the-outlet/Artboard_7_copy_7png_j6chrh.png" />

            <div className='section_1'>
                <img src="https://res.cloudinary.com/emacon-production/image/upload/v1642664420/the-outlet/undraw_Successful_purchase_re_mpig_qud47q.png" alt="" />
            </div>

            <div className='section_2'>
                <h1>THANK YOU! </h1>
                <h2>FOR YOUR PURCHASE</h2>
                <p>Thank you for shopping with us and trusting our products. An email with your order has been sent your way</p>
                <div className='order_link-wrapper'>
                    <Link to="" className='order_link'>
                        Click here to view your order
                    </Link>
                </div>
                
                <div className='subscribe_form'>
                    <div className='subscribe_form-wrapper'>
                        <p>While you wait for your order, do not forget  to subscribe to our newsletter</p>
                        <div className='subscribe_form-form'>
                            <Form
                                flexForm={true}
                                formInputData={subscribeInputData}
                                renderForm={(item, index) => renderSubscribeForm(item, index)}
                                buttonContent={loading ? renderLoading(): "Subscribe"}
                                buttonColor="main-bg"
                                buttonContentColor="white"
                                borderRadius="right"
                                handleForm={handleSubscribeForm}
                            />
                        </div>
                    </div>
                </div>

                <div className='continueShopping_link-wrapper'>
                    <Link to="/" className='continueShopping_link'>
                        Continue Shopping
                    </Link>
                </div>
                
            </div>

            <Footer />
        </div>
    )
}

export default ThankyouMessage;
